export default __webpack_public_path__ + "static/media/ic_left_caret_sm.b8a3f62c.svg";